import {Fragment} from "react";
import {WordPressCalculatorPallet} from "./WordPressCalculatorPallet";

export const WordPressCalculatorItem = ({tab, lng, validatedResult, cbHandlePalletDetail}) => {

    return (
        <Fragment>
            {
                tab === 'ltl' ?
                    <WordPressCalculatorPallet lng={lng}
                                               validatedResult={validatedResult}
                                               cbHandlePalletDetail={cbHandlePalletDetail}/>
                    :
                    <></>

            }
        </Fragment>
    )
}
